export default {"src":"/_next/static/image/public/images/ic_call_blue.5fece3a91445b9ee0444a54a517f4ce0.svg","height":60,"width":60};